import { sqliteTable, text, integer, real } from "drizzle-orm/sqlite-core";

// ============================================================================
// maintenance_types — ประเภทการซ่อม
// ============================================================================
export const maintenanceTypes = sqliteTable("fleet_maintenance_types", {
  id: text("id").primaryKey(), // ULID
  companyId: text("company_id").notNull(),
  name: text("name").notNull(),
  category: text("category", {
    enum: ["preventive", "corrective", "body_repair", "inspection"],
  }),
  defaultIntervalKm: integer("default_interval_km"),
  defaultIntervalMonths: integer("default_interval_months"),
  estimatedCost: real("estimated_cost"),
  isActive: integer("is_active").notNull().default(1),
  sortOrder: integer("sort_order").notNull().default(0),
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
});

export type MaintenanceType = typeof maintenanceTypes.$inferSelect;
export type NewMaintenanceType = typeof maintenanceTypes.$inferInsert;
